import { useEffect, useState } from 'react';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getTimeout, UrlUtils, scrollTop, getAccountUsernameFromPath, Responsive } from '@share/utils';
import { CONDO_SESSION_KEY, Routes, SESSION_KEY_LABEL } from '@share/constants';
import { CondoDetailsWrapper, HotelDetailsWrapper } from '@components';
import { ISessionKey } from '@share/common-types';
import { NULL_VALUE } from '@constants';

const zero = 0;

interface IProps extends RouteComponentProps {
  type: string;
}

function StaticDetailPageComponent(props: IProps) {
  const [loading, setLoading] = useState(true);
  const [isHotel, _setIsHotel] = useState<boolean>(props.type === 'hotel');

  useEffect(() => {
    scrollTop();
    const values = UrlUtils.getValues();
    const routeSearch = isHotel ? Routes.Search : Routes.CondoSearch;
    const sessionKey = isHotel ? SESSION_KEY_LABEL : CONDO_SESSION_KEY;

    const session: ISessionKey = values[sessionKey] as ISessionKey;
    if ((session && session.expireDate && getTimeout(session.expireDate) <= zero)) {
      const accountName = getAccountUsernameFromPath(props.history);
      history.replaceState(null, NULL_VALUE, `/${accountName}${routeSearch}${location.search}`);
      location.reload();
    } 

    setLoading(false);
  }, []);

  return (
    <>
      {loading ? null :
        isHotel ? 
            <div className="hotel-details-page">
              <HotelDetailsWrapper isVacationRentals={false} isStaticDetail={true} />
            </div> :
            <div className="condo-details-page">
              <Responsive>
                <CondoDetailsWrapper isStaticDetail={true} />
              </Responsive>
            </div>
      }
    </>
  );
}

export const StaticDetailPage = connect()(withRouter(StaticDetailPageComponent));